export const LOGIN = 'auth/login'
export const REGISTER = 'auth/register'
export const LOGOUT = 'auth/logout'